import { ActivityUploadStatuses } from "@views/library/constants/activity-upload-status.model";
import HttpClient from "../utils/http-client";

export class LibraryService extends HttpClient {
  async addActivity(activity) {
    return await this.http.post(
      `/client-services/library/activities`,
      activity
    );
  }

  async updateActivityInLibrary(activityId, body) {
    const apiUrl = `/client-services/library/activities/${activityId}`;
    return this.http.put(apiUrl, body);
  }

  async getAllActivityStatuses(
    activityIds = null,
    limit = null,
    offset = null
  ) {
    const apiUrl = `/client-services/library/activities/statuses`;
    const payload = {
      activity_ids: activityIds,
    };

    if (limit !== null) {
      payload.limit = limit;
    }
    if (offset !== null) {
      payload.offset = offset;
    }

    const response = await this.http.post(apiUrl, payload);

    return response;
  }

  async uploadFileToS3(file, presignedUrlData) {
    if (!presignedUrlData || !presignedUrlData.url) {
      throw new Error("Invalid presigned URL data: url is required");
    }

    if (!file) {
      throw new Error("File is required");
    }

    if (!(file instanceof File) && !(file instanceof Blob)) {
      throw new Error(
        `Invalid file type. Expected File or Blob, got ${typeof file}. File: ${file}`
      );
    }

    const renamedFile = new File([file], presignedUrlData.fileName, {
      type: "application/zip",
      lastModified: file.lastModified || Date.now(),
    });

    try {
      const response = await fetch(presignedUrlData.url, {
        method: "PUT",
        body: renamedFile,
        headers: {
          "Content-Type": "application/zip",
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Zip file upload failed with status ${response.status}: ${errorText}`
        );
      }
      return true;
    } catch (error) {
      throw error;
    }
  }
}
